// src/components/InactivityTimer.js
import React, { useState, useEffect, useRef } from 'react'

const InactivityTimer = ({ 
  timeout = 300000, 
  videoUrl = 'https://res.cloudinary.com/hwti4wnct/video/upload/f_auto:video,q_65,w_1200/v1/STATIC/garage-ipads/s4smw01pb7qsnuqmse2u'
}) => {
  const [isInactive, setIsInactive] = useState(false)
  const timeoutRef = useRef(null)
  const videoContainerRef = useRef(null)
  const videoRef = useRef(null)

  // Reset timer when user is active
  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    
    // If the video is showing, hide it
    if (isInactive) {
      setIsInactive(false)
    }
    
    // Set a new timer
    timeoutRef.current = setTimeout(() => {
      setIsInactive(true)
    }, timeout)
  }
  
  // Handle video display based on inactivity state
  useEffect(() => {
    console.log('Inactivity state:', isInactive)
    
    if (isInactive) {
      // Show video container
      if (videoContainerRef.current) {
        videoContainerRef.current.style.display = 'block'
      }
      
      // Play video
      if (videoRef.current) {
        videoRef.current.play().catch(err => {
          console.error('Error playing video:', err)
        })
      }
    } else {
      // Hide video container
      if (videoContainerRef.current) {
        videoContainerRef.current.style.display = 'none'
      }
      
      // Pause video
      if (videoRef.current) {
        videoRef.current.pause()
      }
    }
  }, [isInactive])
  
  // Set up activity listeners
  useEffect(() => {
    // List of events to track
    const events = [
      'mousedown', 'mousemove', 'keydown', 
      'touchstart', 'touchmove', 'scroll', 
      'click', 'keypress'
    ]
    
    // Add event listeners
    events.forEach(event => {
      window.addEventListener(event, resetTimer)
    })
    
    // Start the initial timer
    resetTimer()
    
    // Cleanup when component unmounts
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      
      // Remove event listeners
      events.forEach(event => {
        window.removeEventListener(event, resetTimer)
      })
    }
  }, [timeout])

  return (
    <div 
      ref={videoContainerRef}
      style={{
        display: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        backgroundColor: 'black'
      }}
      onClick={resetTimer}
    >
      <video
        ref={videoRef}
        src={videoUrl}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
        muted
        loop
        playsInline
      />
    </div>
  )
}

export default InactivityTimer